import type { PublicKey } from "@solana/web3.js";
import type { FC } from "react";
import React from "react";

import { shortenAddress } from "../../utils/utils";
import type { ExplorerLinkProps } from "./ExplorerLink";
import { ExplorerLink } from "./ExplorerLink";

export type ExplorerLinkDisplayProps = Omit<ExplorerLinkProps, "address"> & {
  address: string | PublicKey;
  addressLength?: number;
};

export const ExplorerLinkDisplay: FC<ExplorerLinkDisplayProps> = ({ address, type, addressLength = 9, style }) => {
  const addressIdentifier = typeof address === "string" ? address : address?.toBase58();

  if (!addressIdentifier) {
    return null;
  }

  return (
    <ExplorerLink address={addressIdentifier} type={type} style={style}>
      {shortenAddress(addressIdentifier, addressLength)}
    </ExplorerLink>
  );
};
